import { render, staticRenderFns } from "./CalendarWeekLabel.vue?vue&type=template&id=55f7514f&"
import script from "./CalendarWeekLabel.vue?vue&type=script&setup=true&lang=js&"
export * from "./CalendarWeekLabel.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports